<!-- 由 suu 创建于 2025-07-29 星期二 -->
<template>
  <div class="nearby-shop-detail" v-if="shopInfo">
    <!-- 导航栏 -->
    <ShopNavBar
      id="details-bar"
      type="detail"
      :opacity="navBarOpacity"
      @share="handleShare"
    />
    <!-- 顶部背景 -->
    <div class="sd-top-bg">
      <van-swipe :show-indicators="false" @change="handleSwipeChange">
        <van-swipe-item
          v-for="(item, index) in swipeList"
          :key="index"
          @click="handleSwipeClick(index)"
        >
          <img :src="item" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="sd-top-num">
      <span>{{ currentIndex + 1 }}</span
      >/{{ swipeList.length }}
    </div>
    <!-- 渐变块 -->
    <div class="sd-hr"></div>
    <!-- 门店信息 -->
    <div class="sd-info">
      <div class="info-name">{{ shopInfo.name }}</div>
      <div class="info-feature">
        <span
          v-for="(item, index) in shopInfo.feature.split('、')"
          :key="index"
        >
          {{ item }}
        </span>
      </div>
      <div class="info-line"></div>
      <div class="info-row info-address">
        <i class="iconfont icon-dingwei-shixin"></i>
        {{ shopInfo.address }}
      </div>
      <div class="info-row info-locaiton" @click.stop="handleOpenMap">
        <i class="iconfont icon-daohang"></i>
        <span>距离您 {{ formatDistance(shopInfo.distance) }}</span>
        <template v-if="shopRideText">
          <i class="iconfont icon-shufenge"></i>
          <span class="info-ride">{{ shopRideText }}</span>
        </template>
      </div>
      <div class="info-address-btn">
        <div class="btn-item user-btn" @click="handleOpenMap">
          <img
            class="i-icon"
            src="https://cdnvue.gymcity.com.cn/uploads/25shop-detail-icon-map"
          />
          <span class="i-text">查看地图</span>
        </div>
        <div class="btn-item user-btn" @click="handleOpenGuide">
          <img
            class="i-icon"
            src="https://cdnvue.gymcity.com.cn/uploads/25shop-detail-icon-guide"
          />
          <span class="i-text">到店/停车指引</span>
        </div>
      </div>
    </div>
    <!-- 教练团队 -->
    <div class="sd-coachs" v-if="coachs && coachs.length > 0">
      <div class="coachs-title">
        明星教练<span>{{ coachs.length }}人</span>
      </div>
      <div class="coachs-list">
        <div class="coachs-item-wrap">
          <div
            class="coachs-item"
            @click="handleOpenCoach(item)"
            v-for="(item, index) in coachs"
            :key="index"
          >
            <img class="item-image" :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
            <div
              class="item-level"
              v-if="item.level == 'shop_manager' && index == 0"
            >
              店长
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="sd-bot">
      <img
        class="sd-intro"
        src="https://cdnvue.gymcity.com.cn/uploads/25shop-detail-introduce"
      />
      <!-- 按钮 -->
      <div class="sd-btn-know user-btn" @click="handleOpenKnow">了解健萌</div>
      <!-- 注意事项 -->
      <img
        class="sd-precautions"
        src="https://cdnvue.gymcity.com.cn/uploads/25shop-detail-precautions"
      />
    </div>
    <UgcList :shopId="shopid" />
    <!-- 约课按钮 -->
    <div class="sd-btn-ksyk-btn-wrap" v-if="coachs && coachs.length > 0">
      <div
        class="sd-btn-lxd-btn"
        @click="handleOpenLxd"
        v-if="coachs[0].level == 'shop_manager'"
        >联系店长</div
      >
      <div class="sd-btn-ksyk-btn" @click="handleOpenKsyk">快速约课</div>
    </div>
    <!-- <img
      class="sd-btn-ksyk"
      @click="handleOpenKsyk"
      src="https://cdnvue.gymcity.com.cn/uploads/25shop-detail-btn-ksyk?v=1"
    /> -->
    <!-- 圈子 -->
  </div>
  <vLoading v-else />
</template>

<script>
import ShopNavBar from './ponents/ShopNavBar.vue'
import { eventObj } from '@/components/app/share/share-method.js' // 分享组件
import { ImagePreview } from 'vant'
import UgcList from './ponents/ugc-list.vue'
export default {
  name: 'nearby-shop-detail',

  components: {
    ShopNavBar,
    UgcList
  },

  props: {},

  data() {
    return {
      shopid: this.$route.query.shopid || null,
      shopInfo: null,
      coachs: [], // 门店团队
      currentIndex: 0, // 当前图片索引
      navBarOpacity: 0 // 导航栏透明度
    }
  },

  computed: {
    swipeList() {
      let list = []
      if (this.shopInfo.all_images) {
        list = this.shopInfo.all_images.split(';')
      } else {
        list = [this.shopInfo.images]
      }
      return list.map((item) => {
        return item + '?x-oss-process=image/resize,m_lfit,w_750'
      })
    },
    shopRideText() {
      if (!this.shopInfo.distance) {
        return ''
      } else if (this.shopInfo.distance > 1000) {
        return `驾车约${this.shopInfo.card_ride}分钟到达`
      } else {
        return `步行约${this.shopInfo.human_ride}分钟到达`
      }
    }
  },

  watch: {},

  created() {
    this.shopInfo = this.$store.state.curShop || null
    this.getShopInfo()
    this.loadData()
  },

  mounted() {
    document.addEventListener('scroll', this.bindScroll, {
      passive: false
    })
  },

  destroyed() {
    document.removeEventListener('scroll', this.bindScroll)
  },

  methods: {
    // 预览图片
    handleSwipeClick(index) {
      ImagePreview({
        images: this.swipeList,
        startPosition: index
      })
    },
    // 分享
    handleShare() {
      // 获取环境变量并设置默认值
      const env = this.$http.getEnv()
      const baseUrlMap = {
        Pro: 'https://vue.gymcity.com.cn/?path=',
        Test: 'https://test.gymcity.com.cn/?path=',
        Default: 'http://vue.gym2.com/?path='
      }
      const baseUrl = baseUrlMap[env] || baseUrlMap.Default
      const shareOptions = {
        //分享参数
        url: `${baseUrl}nearby-shop-details&shopid=${this.shopid}`,
        title: `健萌健身【${this.shopInfo.name}】`,
        desc: '明星同款私教馆',
        thumbnail: 'https://cdnvue.gymcity.com.cn/uploads/pub-logo-zfx'
      }
      eventObj.shareLinkToWxFriend(shareOptions)
    },
    // 联系店长
    handleOpenLxd() {
      this.$router.push(
        'coach-wxwork-card?cType=shop_manager&cid=' + this.coachs[0].coachid
      )
    },
    // 约课
    handleOpenKsyk() {
      sessionStorage['autoShowShopCourseName'] = this.shopInfo.name
      this.$router.push('/subscribe')
    },
    // 了解健萌
    handleOpenKnow() {
      this.$http._toVueH5Url('understantgym', 'push', '了解健萌')
    },
    // 跳转到店指引
    handleOpenGuide() {
      this.$http._toVueH5Url(
        'shop-route-guide?tfrom=shopdetail&shopid=' + this.shopid
      )
    },
    // 查看地图
    handleOpenMap() {
      this.$betterwe.jumpRoute(
        `/mapLauncher?latitude=${parseFloat(
          this.shopInfo.lat
        )}&longitude=${parseFloat(this.shopInfo.lon)}&title=${
          this.shopInfo.name
        }`
      )
    },
    // 跳转到教练详情
    handleOpenCoach(item) {
      // 获取教练信息
      this.$toast.loading('加载中···')
      this.$http
        .get('member/active?a=coachCard', {
          cid: item.coachid
        })
        .then((rs) => {
          // this.$toast.clear()
          if (rs.data.code === 200 && rs.data.data) {
            this.toDetail(rs.data.data)
          } else {
            this.$dialog({ message: `教练信息获取失败：${rs.data.msg}` })
          }
        })
        .catch((err) => {
          this.$dialog({ message: '网络错误' })
          this.$toast.clear()
        })
    },
    /**
     * 自主约课 跳转教练排课详情
     * @param cid 教练ID
     * @param obj 教练信息
     */
    toDetail(obj) {
      let detailData = obj
      let currDay = this._getCurDay()
      // 教练详情默认请求此日期的排课信息
      detailData['coursetime'] = currDay
      if (Object.keys(detailData).length > 0) {
        this.$store.commit('setDetailData', detailData)
        this.$store.commit('setCurrDay', currDay)
        this.$toast.clear()
        this.$router.push({
          path: '/subscribe/detail'
        })
      }
    },
    //  * 获取当日 格式
    _getCurDay() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = this.day ? new Date(this.day.replace(/-/g, '/')) : new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + day,
        week: week[date.getDay()]
      }
      return obj
    },
    // 获取门店团队
    loadData() {
      this.$toast.loading('加载中……')
      this.$http
        .get('coach/index?a=shopCoachs', {
          sid: this.shopid
        })
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code === 200) {
            let result = rs.data.data
            this.coachs = result.coachs || []
          }
        })
    },
    // 获取门店信息
    getShopInfo() {
      const location = this.$store.state.location
      let lat = location?.lat || ''
      let lon = location?.lng || ''
      this.$http
        .get(`/member/index?a=getShopInfo`, {
          lat,
          lon,
          shopid: this.shopid
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.shopInfo = res.data.data || null
          }
        })
    },
    handleSwipeChange(index) {
      this.currentIndex = index
    },
    // 监听页面滑动 控制nav不透明度
    bindScroll(e) {
      let minHeight = 50
      let maxHeight = 150
      var scroll = window.scrollY
      if (scroll < minHeight) {
        this.navBarOpacity = 0
      } else if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(pecent.toFixed(2))
      }
    },
    // 计算距离
    formatDistance(val) {
      if (!val) {
        return '未知'
      }
      return Number(val) < 1000
        ? String(val).split('.')[0] + 'm'
        : (Number(val) / 1000).toFixed(1) + 'km'
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.nearby-shop-detail {
  width: 100vw;
  box-sizing: border-box;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(72);
  .sd-top-bg {
    width: 100%;
    height: 210px;
    box-sizing: border-box;
    position: relative;
    & > .van-swipe {
      width: 100%;
      height: 100%;
      .van-swipe-item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        mask-image: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 1) 75%,
          rgba(0, 0, 0, 0) 100%
        );
      }
    }
  }
  .sd-hr {
    width: 100%;
    box-sizing: border-box;
    height: 465px;
    background: linear-gradient(
      180deg,
      rgba(174, 174, 174, 0) 0%,
      #f9f9f9 18%,
      #f9f9f9 60%,
      #ffffff 100%
    );
    position: absolute;
    top: vw(158);
    z-index: 1;
  }
  .sd-top-num {
    height: 20px;
    padding: 0 10px;
    box-sizing: border-box;
    position: absolute;
    top: 163px;
    right: 20px;
    z-index: 2;
    color: #fff;
    background-color: rgba($color: #050b27, $alpha: 0.8);
    font-size: 13px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 99px;
    span {
      font-weight: 600;
    }
  }
  .sd-info {
    width: 355px;
    box-sizing: border-box;
    padding: 20px;
    padding-top: 15px;
    background: linear-gradient(180deg, #fdfdfd 0%, #ffffff 20%, #ffffff 100%);
    border-radius: 8px;
    backdrop-filter: blur(10px);
    position: relative;
    z-index: 2;
    margin-top: -16px;
    .info-name {
      font-weight: 600;
      font-size: 22px;
      color: #050b27;
      line-height: 30px;
    }
    .info-feature {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 7px;
      margin-left: -4px;
      span {
        padding: 3px 10px;
        background: #f1f1f1;
        border-radius: 4px;
        font-weight: 400;
        font-size: 10px;
        color: rgba($color: #050b27, $alpha: 0.8);
        margin-left: 4px;
      }
    }
    .info-line {
      width: 100%;
      height: 1px;
      box-sizing: border-box;
      background-color: #f1f1f1;
      margin-top: 16px;
    }
    .info-row {
      display: flex;
      align-items: baseline;
      word-break: break-all;
      font-size: 13px;
      .iconfont {
        color: #050b27;
        font-size: 11px;
        font-weight: 600;
        margin-right: 5px;
      }
      &.info-address {
        margin-top: 10px;
        color: #050b27;
        line-height: 20px;
      }
      &.info-locaiton {
        margin-top: 9px;
        line-height: 18px;
        .icon-shufenge {
          margin: 0 8px;
          color: #979797;
        }
        .info-ride {
          color: rgba($color: #050b27, $alpha: 0.5);
        }
      }
    }
    .info-address-btn {
      width: 100%;
      box-sizing: border-box;
      margin-top: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn-item {
        width: 155px;
        height: 36px;
        box-sizing: border-box;
        background: #f7f7f7;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        .i-icon {
          width: 24px;
          margin-right: 10px;
        }
        .i-text {
          font-size: 13px;
          color: #050b27;
        }
      }
    }
  }
  .sd-coachs {
    width: 100%;
    box-sizing: border-box;
    margin-top: 20px;
    position: relative;
    z-index: 2;
    .coachs-title {
      padding-left: 20px;
      font-weight: 600;
      font-size: 16px;
      color: #050b27;
      line-height: 22px;
      span {
        font-size: 14px;
        color: rgba($color: #050b27, $alpha: 0.5);
        font-weight: 400;
        margin-left: 5px;
      }
    }
    .coachs-list {
      width: 100%;
      box-sizing: border-box;
      padding-left: 20px;
      position: relative;
      margin-top: 10px;
      overflow-x: auto;
      .coachs-item-wrap {
        width: fit-content;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        .coachs-item {
          margin-right: 5px;
          position: relative;
          .item-image {
            width: 90px;
            height: 90px;
            object-fit: cover;
            border-radius: 4px;
          }
          .item-name {
            font-size: 13px;
            color: #050b27;
            line-height: 18px;
            margin-top: 5px;
            text-align: center;
          }
          .item-level {
            width: 28px;
            height: 14px;
            background: #ff2270;
            border-radius: 4px 0px 4px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 9px;
            color: #ffffff;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }
  .sd-bot {
    width: 355px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #f9f9f9;
    position: relative;
    padding-top: 29px;
    padding-bottom: 26px;
    margin-top: 20px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    .sd-intro {
      width: 100%;
      width: 355px;
      display: block;
    }
    .sd-btn-know {
      width: 305px;
      height: 36px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 18px;
      border: 1px solid #dddddd;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #050b27;
      margin-top: 20px;
    }
    .sd-precautions {
      width: 100%;
      display: block;
      margin-top: 20px;
    }
  }
  .sd-btn-ksyk {
    width: 347px;
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    bottom: calc(constant(safe-area-inset-bottom));
    bottom: calc(env(safe-area-inset-bottom));
    z-index: 9;
  }
  .sd-btn-ksyk-btn-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    align-items: center;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 34px;
    bottom: calc(34px + constant(safe-area-inset-bottom));
    bottom: calc(34px + env(safe-area-inset-bottom));
    z-index: 9;
    .sd-btn-lxd-btn {
      width: 120px;
      height: 48px;
      box-sizing: border-box;
      background: #ffeaf1;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.4);
      border-radius: 25px;
      border: 1px solid #ffffff;
      font-weight: 500;
      font-size: 18px;
      color: #ff2270;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .sd-btn-ksyk-btn {
      flex: 1;
      height: 48px;
      box-sizing: border-box;
      background: #ff2270;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.4);
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
